// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import { actionCreatorsList } from '../../../redux/rootActionCreator';
import { RootState } from '../../../redux/rootReducer';
import notificationsSelector from '../../../redux/selectors/notificationsSelector';
import Header from './Header';

const {
  readNotificationActions,
  getResetNotificationsActions,
  getNotificationsActions,
} = actionCreatorsList;

const mapStateToProps = (state: RootState, ownProps: any) => {
  const selector = createStructuredSelector<any, any>({
    isNotificationFetching: notificationsSelector.makeNotificationsByKey('isFetching'),
    notificationsList: notificationsSelector.makeNotificationsList(),
    notificationsCount: notificationsSelector.makeNotificationsByKey('count'),
    isResetingNotifications: notificationsSelector.makeIsResetingNotifications(),
    unreadNotifications: notificationsSelector.makeNotificationsUnread(),
  });

  return (state: RootState) => ({
    ...selector(state),
  });
};

// @ts-ignore
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getNotifications: getNotificationsActions.request,
      readNotification: readNotificationActions.request,
      getResetNotifications: getResetNotificationsActions.request
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
